var Marionette = require('marionette'),
    RaphaelView = require('raphaelItemView'),
    _ = require('underscore'),
    SelectHandle = require('./selectHandle'),
    ShapeUtils = require('../../../models/shapeUtils');

require('extendRaphael');


var instVars = {

    parent: null,
    handleSet: null, //( Raphael set which is the el of the Raphael View)

    /* cached on init */
    _pathIsRect: null,
    _hasBorderView: null,
    _paper: null,
    _pgRotation: null

};

var aCursors = ['nw-resize', 'ne-resize', 'se-resize', 'sw-resize' ]; //in order (clockwise) --- for dragging

/* DO NOT PUT HANDLES INTO CHILDVIEWS AND SET -- OTHERWISE MEMORY ERROR ... yrs ago ...*/
module.exports = RaphaelView.extend({

    initialize: function(options) {

        _.extend( this, instVars,
            _.pick( options, 'parent', '_pathIsRect', '_hasBorderView', '_paper', '_pgRotation')
        );

        this.bindEntityEvents( this.parent, this.parentSubs );


    },
    parentSubs: {
        'shape.move':                               'move',         // transform w/mouse move
        'shape.onAfterBaseScale shape.moveEnd':     'reposition',   // like burning pts in
        'shape.resizeRect':                         'resizeRect'    // note: poly resize is different (reposition?)
    },
    /*
    * If changed, set the new shape -- it must come from path ...
    * when redo on resize, setPoints won't work b/c get path coordinates
    * */
    render: function( emptySet ) {

        this.handleSet = emptySet;
        this._createHandleViews( this._getPointsFromPath() );
        this.setElement(this.handleSet);

        return this;
    },
    /*
    * Point consists of {x, y, cursor, id -- (id is the index in the array)}
    * */
    _createHandleViews: function( aPts ) {

        _.each( aPts, function(pt, i) {

            this.handleSet.push( new SelectHandle({
                pt: pt,
                shapeView: this.parent
            }).el );

        }, this);

    },
    /*
    *
    * Like a reset ('bakeTrans'): set the new pt from the path and remove the transform.
    * Assumes path (equiv to back in transformed pts)  // don't need hide/show
    * Note: this could be optimized ...
    * */
    reposition: function() {

        _.each( this._getPointsFromPath(), function(pt, i) {

            this.el[i].attr({
                cx: pt.x,
                cy: pt.y
            }).transform('');

        },this);

    },
    move: function( box, dx, dy ) {

        this.el.transform( 'T' + dx + ',' + dy );

    },
    /*
    * If using the bbox, using the actuals.
    * TODO: use same fn for resize w/ conditional (?)
    * */
    resizeRect: function( elBox ) {

        var h = this.handleSet,
            b = elBox;

        h[0].attr({cx: b.x ,    cy: b.y });
        h[1].attr({ cx: b.x2,    cy: b.y });
        h[2].attr({ cx: b.x2 ,   cy: b.y2 });
        h[3].attr({ cx: b.x,     cy: b.y2});

    },
    /*
    * Note: also sets the cursors for resizing
    * */
    _getPointsFromPath: function() {

        var pts,
            shapeEl = this.parent.el,
            hasSelectedBorder = this._hasBorderView;

        if ( hasSelectedBorder ) {

            // TODO: optimize? -- eg for reposition --- fn to return with creation of dummy shape

            var dummyEl = this._paper.path( shapeEl.getPathOfBBox(), 1)
                .hide();

            pts = dummyEl.getPathCoordinates();  /* returns an array {x:y} of all points in the path -- equiv to getBBox for rectangles */

            dummyEl.remove();

        } else { // all others including rect, poly

            pts = shapeEl.getPathCoordinates();

            /*
            * DVBC-1634 -- quick fix: if page is rotated, the path may not be in 'rect order'
            * -- meaning from tl, tr, br, bl.
            * We need this for setting the correct 'hover cursors' and for dragging logic ( getBoxTransformStr ).
            * In it's current form, this could be optimized (eg called on scale)
            * But a 'rewrite' using shapes with transforms is a MUCH better long term solution.
            * */
            if ( this._pgRotation !== 0 && this._pathIsRect ) {
                pts = ShapeUtils.getPtsInRectOrder( pts );
            }

        }

        /* then set cursor attributes on the points */
        this._pathIsRect || hasSelectedBorder
            ?   _.each( pts, function( p, i ) {
                    _.extend( p, { cursor: aCursors[i], id: i} );
                }, this)
            :   _.each( pts, function( p, i ) {
                    _.extend( p, { cursor:'nesw-resize', id: i });   //TODO: indicate this is the constant being used
                });

        return pts;

    },

    /**
     * TODO:
     * - the handleset should be a view with an all as a Raphael set, now it's just a the set
     * - are the events undelegated in child?
     * - needed?
     */

    onBeforeDestroy: function() {
        // this.handleSet.destroy();
        this.unbindEntityEvents(this, this.parentSubs);
        this.el.remove().clear();
        this.remove();

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/selectHandles.js
 ** module id = 195
 ** module chunks = 0
 **/